module.exports = __webpack_public_path__ + "static/media/ph.e75d5f2f.png";